// constants
import { SELECTORS } from '@/scripts/constants';

// component
import Component from '../Component';

// assets
import './Tabs.scss';

export class Tabs extends Component {
  _updateView() {
    const { links, content } = this._props;
    const { activeTab } = this._state;

    links.forEach((link, i) => {
      link.classList.toggle(SELECTORS.active, i === activeTab);
    });
    content.forEach((item, i) => {
      item.classList.toggle(SELECTORS.active, i === activeTab);
    });
  }

  _setupEvents() {
    const { links } = this._props;
    links.forEach((link, i) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this._setState({
          activeTab: i,
        });
      });
    });
  }

  init() {
    super.init();
    this._setupEvents();
  }
}
